/* Sovereign Abundance pre-sell pages (step 14: ADV, CMP, QZ). Hand-written from the kit's ev-article.js.
   1. Line above the title per ad: the ad name is read from ad_name (Whop reserves utm_content and passes the Meta ad
      name as ad_name), else utm_content; the concept code (C04, C05, C06) read anywhere in it swaps [data-cNN];
      then the ad's format word (ui-mockup, ugc-image, native-long-copy, comparison, news-style,
      crossed-out-enemy) swaps [data-f-<format>], since the three ads of one concept share the code.
   2. Every link to the product page (a[data-pdp]) carries every parameter of the page URL (utm_*, fbclid, ad_name and
      Whop's own click ids), except theme preview ones; a click publishes lp_cta_click.
   3. QZ: the quiz, one screen at a time; the most frequent tag (N, A, W; ties go to A) picks the result; a belief card
      (button data-card) only moves on; the anchor question (data-k) shows the matching .qanchor line under the result;
      nothing is stored; every screen answered is published as lp_quiz_step (drop-off per screen), the result as
      lp_quiz_result. */
(function () {
  var q = new URLSearchParams(location.search);
  var uc = (q.get('ad_name') || q.get('utm_content') || '').toLowerCase();
  var m = uc.match(/(?:^|_)(c\d\d)(?=[a-z]?(?:_|$))/);
  var key = m ? m[1] : null;
  if (key) document.querySelectorAll('[data-' + key + ']').forEach(function (el) { el.innerHTML = el.getAttribute('data-' + key); });
  ['ui-mockup', 'ugc-image', 'native-long-copy', 'comparison', 'news-style', 'crossed-out-enemy'].forEach(function (f) {
    if (uc.indexOf('_' + f + '_') > -1) document.querySelectorAll('[data-f-' + f + ']').forEach(function (el) { el.innerHTML = el.getAttribute('data-f-' + f); });
  });
  var page = document.body.getAttribute('data-lp') || 'lp';
  function pub(name, data) { try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {} }

  var pass = [];
  q.forEach(function (v, k) { if (!/^(view|preview_theme_id|_ab|_fd|_sc|tier|qty|variant)$/.test(k)) pass.push(encodeURIComponent(k) + '=' + encodeURIComponent(v)); });
  document.querySelectorAll('a[data-pdp]').forEach(function (a, i) {
    if (pass.length) a.href += (a.href.indexOf('?') > -1 ? '&' : '?') + pass.join('&');
    a.addEventListener('click', function () { pub('lp_cta_click', { page: page, link: i + 1, concept: key || 'default' }); });
  });

  var box = document.getElementById('quiz');
  if (!box) return;
  var steps = box.querySelectorAll('.qstep'), bar = document.getElementById('qbar'), back = document.getElementById('qback'), picks = [], kpick = null, i = 0;
  function show() {
    steps.forEach(function (s, k) { s.classList.toggle('on', k === i); });
    if (bar) bar.style.width = (i / steps.length * 100) + '%';
    if (back) back.classList.toggle('on', i > 0 && i < steps.length);
  }
  function finish() {
    var n = { N: 0, A: 0, W: 0 }; picks.forEach(function (t) { if (n[t] !== undefined) n[t]++; });
    var r = 'A'; if (n.N > n[r]) r = 'N'; if (n.W > n[r]) r = 'W';
    box.querySelectorAll('.qres').forEach(function (el) { el.classList.toggle('on', el.getAttribute('data-r') === r); });
    box.querySelectorAll('.qanchor').forEach(function (el) { el.classList.toggle('on', el.getAttribute('data-k') === kpick); });
    var nx = box.querySelector('.qnext'); if (nx) nx.classList.add('on');
    if (bar) bar.style.width = '100%'; if (back) back.classList.remove('on');
    pub('lp_quiz_result', { page: page, result: r, anchor: kpick || 'none', concept: key || 'default' });
  }
  box.addEventListener('click', function (e) {
    var b = e.target.closest('.qstep button');
    if (b) { e.preventDefault(); var t = b.getAttribute('data-t'), k = b.getAttribute('data-k'); picks[i] = t; if (k !== null) kpick = k; pub('lp_quiz_step', { page: page, step: i + 1, screen: steps[i].getAttribute('data-q'), answer: t || k || 'next', concept: key || 'default' }); i++; if (i < steps.length) show(); else { steps.forEach(function (s) { s.classList.remove('on'); }); finish(); } return; }
    if (e.target === back) { e.preventDefault(); if (i > 0) { i--; show(); } }
  });
  show();
})();

/* FALL25 and the launch gifts end on the Sunday of the current week in New York (today on a Sunday): rolling,
   never out of date (William, 2026-10-29). .js-deadline "Sunday, November 1" · .js-deadline-short "Sun, Nov 1" ·
   .js-deadline-md "Nov 1"; the text written in the page is the fallback without JavaScript. */
(function () {
  var els = document.querySelectorAll('.js-deadline, .js-deadline-short, .js-deadline-md');
  if (!els.length) return;
  var d;
  try { d = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' })); } catch (e) { d = new Date(); }
  d.setDate(d.getDate() + (7 - d.getDay()) % 7);
  var D = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var M = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var day = D[d.getDay()], mon = M[d.getMonth()], n = d.getDate();
  els.forEach(function (e) {
    e.textContent = e.classList.contains('js-deadline-md') ? mon.slice(0, 3) + ' ' + n
      : e.classList.contains('js-deadline-short') ? day.slice(0, 3) + ', ' + mon.slice(0, 3) + ' ' + n
      : day + ', ' + mon + ' ' + n;
  });
})();
